module.exports = __webpack_public_path__ + "image/pro_icon5.png";